import React, { useEffect } from 'react';

import { useToast, ToastMessage } from '~/hooks/toast';
import { Container } from './styles';

interface ToastProps {
  message: ToastMessage;
  style: object;
}

const icons = {
  info: 'ni-check-info',
  danger: 'ni-check-times',
  success: 'ni-check-circle',
};

const Toast: React.FC<ToastProps> = ({ message, style }) => {
  const { removeToast } = useToast();

  useEffect(() => {
    const timer = setTimeout(() => {
      removeToast(message.id);
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, [message.id, removeToast]);

  return (
    <Container
      type={message.type}
      style={style}
      onClick={() => removeToast(message.id)}
    >
      <div>
        <em className={`icon ni ${icons[message.type || 'info']}`} />

        <div>
          <strong>{message.description}</strong>
        </div>
      </div>
    </Container>
  );
};

export default Toast;
